import { ValidatorResult } from '@/models/validation-result.model';
import { ProductPricesRequestDto, ProductPricesResponseDto } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class ProductsPricesService {
  private crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<any>('api/prices');
  }

  public async getProductPrices(
    productPricesRequest: ProductPricesRequestDto,
    accountId: string,
  ): Promise<ValidatorResult<ProductPricesResponseDto[]>> {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);

    return await this.crudService.do('post', `?${queryParams}`, productPricesRequest);
  }
}
